<template>
  <div v-if="listData.length > 0">
    <table class="b2b-grid b2b-grid--collapse is-compact" qaid="backorder-allocated-saved-list-sku-grid">
      <thead class="b2b-grid__header">
        <!-- Each Header -->
        <tr>
          <th class="b2b-grid__cell b2b-grid__head" qaid="backorder-allocated-eta-grid-header.checkbox">
            <label class="checkbox">
              <input
                id="backorder-allocated-eta-settings-select-all"
                v-model="selectAllCheckboxes"
                type="checkbox"
                @change="toggleSelectAll"
              />
              <span class="control-indicator"></span>
            </label>
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.sku">
            {{ getBaseProperty('sku') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.line-note">
            {{ getBaseProperty('lineNote') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.item">
            {{ getBaseProperty('item') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.order-number">
            {{ getBaseProperty('orderNumber') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.customer-po">
            {{ getBaseProperty('customerPo') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.upc">
            {{ getBaseProperty('upc') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.warehouse">
            {{ getBaseProperty('warehouse') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.original-eta">
            {{ getBaseProperty('original-eta') }}
          </th>
          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.current-eta">
            {{ getBaseProperty('current-eta') }}
          </th>
          <th
            class="b2b-grid__cell b2b-grid__head  whitespace-nowrap"
            data-type="stock-watch"
            qaid="backorder-allocated-eta-grid-header.stockwatch"
          >
            {{ getBaseProperty('eta-watch') }}
          </th>

          <th class="b2b-grid__cell b2b-grid__head " qaid="backorder-allocated-eta-grid-header.price">
            {{ getBaseProperty('price') }}
          </th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(item, itemIndex) in paginatedData">
          <tr :key="item.id">
            <td class="b2b-grid__cell lg:table-cell">
              <label class="checkbox">
                <input
                  :id="`item-${itemIndex}`"
                  v-model="item.checkboxActive"
                  type="checkbox"
                  :disabled="item.etaWatch === false"
                />
                <span class="control-indicator"></span>
              </label>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.sku">
              <div class="b2b-grid__label ">{{ getBaseProperty('sku') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.sku}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.line-note">
              <div class="b2b-grid__label ">{{ getBaseProperty('lineNote') }}</div>
              <div class="b2b-grid__content">
                <grid-note
                  v-if="!item.isConsumer"
                  :data="{
                    value: 'note_add',
                    editable: true,
                    content: item.lineComment ? item.lineComment : '',
                    hasNotification: item.lineComment != null && item.lineComment.length,
                  }"
                  :item-id="`item-${itemIndex}`"
                  :max-length="60"
                  :base-properties="baseProperties"
                  @note-added="addNote(item, $event)"
                />
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.itemname">
              <div class="b2b-grid__label ">{{ getBaseProperty('item') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.itemName}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.order-number">
              <div class="b2b-grid__label ">{{ getBaseProperty('orderNumber') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.orderNumber}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.customer-po">
              <div class="b2b-grid__label ">{{ getBaseProperty('customerPo') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.customerPo}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.upc">
              <div class="b2b-grid__label ">{{ getBaseProperty('upc') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.upc}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.warehouse">
              <div class="b2b-grid__label ">{{ getBaseProperty('warehouse') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.warehouse}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.original-eta">
              <div class="b2b-grid__label ">{{ getBaseProperty('original-eta') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.etaDate}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.estimated-ship-date">
              <div class="b2b-grid__label ">{{ getBaseProperty('original-eta') }}</div>
              <div class="b2b-grid__content">
                <grid-text :data="{value: item.estimatedShipDate}"></grid-text>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.stockwatch">
              <div class="b2b-grid__label ">{{ getBaseProperty('stockwatch') }}</div>
              <div class="b2b-grid__content">
                <grid-eta-watch :eta-item="item" :token="token" :base-properties="baseProperties"></grid-eta-watch>
              </div>
            </td>
            <td class="b2b-grid__cell lg:table-cell" qaid="backorder-allocated-eta-grid.price">
              <div class="b2b-grid__label ">{{ getBaseProperty('price') }}</div>
              <div class="b2b-grid__content">
                <grid-price :data="{dealerCost: item.unitPrice}"></grid-price>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="md:flex md:justify-end">
      <div class="md:flex md:flex-grow text-center">
        <pagination
          v-if="pageCount > 1"
          ref="pagination"
          qaid="backorder-allocated-eta-grid.pagination"
          :page-number="pageNumber"
          :page-count="pageCount"
          @page-change="pageChange"
          @prev-page="prevPage"
          @next-page="nextPage"
        ></pagination>
      </div>

      <div class="buttons buttons--right">
        <trek-link
          id="manage-allocated-items-link"
          button
          primary
          :href="`${encodedContextPath}/checkout/`"
        >
          <span v-html="bp('manageAllocatedItems')"></span>
        </trek-link>
        <trek-button
          primary
          qaid="backorder-allocated-eta-grid.removebutton"
          :disabled="selectedSkus.length === 0"
          @click="openDialog"
        >
          <span v-html="getBaseProperty('remove-watch')"></span>
        </trek-button>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="getBaseProperty('delete-message')"
      :center="true"
      :show-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
      :z-index="16000011"
      :close-dialog-tooltip="bp('closeDialogToolTip')"
      qaid="backorder-allocated-eta-grid.modal"
      @close="closeDialog"
    >
      <template slot="footer">
        <div class="buttons buttons--center">
          <trek-button alert qaid="backorder-allocated-eta-grid.delete.yes" @click="confirmDelete">
            <span v-html="getBaseProperty('delete-yes')"></span>
          </trek-button>
          <trek-button secondary qaid="backorder-allocated-eta-grid.delete.no" @click="closeDialog">
            <span v-html="getBaseProperty('delete-no')"></span>
          </trek-button>
        </div>
      </template>
    </el-dialog>
  </div>
  <div v-else>
    <pdl-callout>
      <template #content>
        <span v-html="noItem" />
      </template>
    </pdl-callout>
  </div>
</template>

<script>
import find from 'lodash/find';
import {mapState} from 'vuex';
import pagination from '../../../mixins/pagination';
import ElDialog from '../../Dialog.vue';
import axios from 'axios';
import {PdlCallout} from '@pedal/pdl-callout';
import GridText from '@/components/grid/GridText';
import GridEtaWatch from '@/components/grid/GridEtaWatch';
import GridPrice from '@/components/grid/GridPrice';
import Pagination from '@/components/Pagination';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import GridNote from '@/components/grid/GridNote';

export default {
  components: {ElDialog, GridText, PdlCallout, GridEtaWatch, GridPrice, Pagination, TrekButton, TrekLink, GridNote},
  mixins: [pagination],
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    token: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      required: false,
      default: 15,
    },
    noItem: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selectAllCheckboxes: false,
      dialogVisible: false,
    };
  },
  computed: {
    listData() {
      return this.items;
    },
    selectedSkus() {
      return this.items.filter((item) => item.checkboxActive === true && item.etaWatch === true);
    },
    ...mapState('backend', ['encodedContextPath']),
  },
  methods: {
    getBaseProperty(name) {
      let baseProperty = find(this.baseProperties, (baseProperty) => baseProperty.name === name);
      return baseProperty ? baseProperty.label : '';
    },
    async addNote(item, note) {
      const payload = {
        orderLineNumber: item.orderLineNumber,
        orderNumber: item.orderNumber,
        orderType: item.orderType,
        orderCompany: item.orderCompany,
        lineComment: note.content,
      };
      axios
        .post(`/allocated/item/comment/update`, payload)
        .then((response) => {
          if (response.data.meta.feedback.type === 'success') {
            this.$set(item, 'lineComment', note.content);
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateDataList() {
      this.$emit('update-data-list');
    },
    toggleSelectAll(event) {
      this.items.map((item) => {
        item.checkboxActive = event.target.checked;
        return item;
      });
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    confirmDelete() {
      this.dialogVisible = false;
      let successCallCounter = 0,
        failureCallCounter = 0,
        totalCallsToMake = this.selectedSkus.length;

      this.selectedSkus.map((mappedItem) => {
        const token = $('[name="CSRFToken"]').val();
        axios
          .delete(`/my-account/etawatch/${mappedItem.etaWatchId}?CSRFToken=${token}`)
          .then(
            ({
              data: {
                meta: {feedback},
              },
            }) => {
              if (feedback.type === 'success') {
                successCallCounter++;
              } else {
                failureCallCounter++;
              }

              /* NOTE: Show success message when all selected items have successfully updated */
              if (successCallCounter === totalCallsToMake) {
                this.$emit('update-data-list');
                this.$notify({
                  type: 'success',
                  message: this.getBaseProperty('delete-confirmation'),
                });
              } else if (successCallCounter + failureCallCounter === totalCallsToMake) {
                /* NOTE: Just update the table when at least one item failed to be updated */

                this.$emit('update-data-list');
              }
            }
          )
          .catch((error) => console.log(error));
      });
    },
  },
};
</script>
